export default {
    'widgets.notifications.fusion-swap-view.status.pending': 'قيد الانتظار',
    'widgets.notifications.fusion-swap-view.status.filled': 'مكتمل',
    'widgets.notifications.fusion-swap-view.status.false-predicate': 'معبأ',
    'widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance': 'معبأ',
    'widgets.notifications.fusion-swap-view.status.partially-filled': 'معبأ',
    'widgets.notifications.fusion-swap-view.status.wrong-permit': 'معبأ',
    'widgets.notifications.fusion-swap-view.status.invalid-signature': 'معبأ',
    'widgets.notifications.fusion-swap-view.status.expired': 'منتهي الصلاحية',
    'widgets.notifications.fusion-swap-view.status.cancelled': 'ملغى',
    'widgets.notifications.fusion-swap-view.control.cancel': 'إلغاء',
};
//# sourceMappingURL=ar.js.map